import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import ContactDuplicateModel from 'donor-elf-web/models/contact-duplicate';
import ReviewItemModel from 'donor-elf-web/models/review-item';
import { type JournalReviewItemRouteModel } from 'donor-elf-web/routes/funds/fund/journals/journal/review-items';

export class JournalReviewItem {
  constructor(args: {
    contactDuplicate?: ContactDuplicateModel;
    reviewItem?: ReviewItemModel;
  }) {
    this.contactDuplicate = args.contactDuplicate;
    this.reviewItem = args.reviewItem;
  }

  contactDuplicate?: ContactDuplicateModel;
  reviewItem?: ReviewItemModel;

  @tracked processed: boolean = false;
}

export default class JournalReviewItemController extends Controller {
  declare model: JournalReviewItemRouteModel;

  get allItemsProcessed() {
    return this.model.items.every((x) => x.processed);
  }

  @action
  handleProcessed(item: JournalReviewItem) {
    item.processed = true;
  }
}
